import { fetchWrapRPC } from '../services/api';
import {
  CancelJobRequest,
  CancelJobResponse,
  DeleteJobRequest,
  DeleteJobResponse,
  JobService_CancelJob,
  JobService_DeleteJob,
  JobService_ListJobs,
  ListJobsRequest,
  ListJobsResponse,
} from './gen/ai/h2o/mlops/batch/v1/job_service_pb';

const PATH_PREFIX = '/batch'; // Previously '/deploymentServer/batch';

export const cancelJob = (
  mlopsApiUrl: string,
  request: CancelJobRequest,
  requestInit?: { signal?: AbortSignal }
): Promise<CancelJobResponse> => {
  return fetchWrapRPC<CancelJobRequest, CancelJobResponse>(JobService_CancelJob, {
    basePath: `${mlopsApiUrl}${PATH_PREFIX}`,
  })(request, requestInit);
};

export const deleteJob = (
  mlopsApiUrl: string,
  request: DeleteJobRequest,
  requestInit?: { signal?: AbortSignal }
): Promise<DeleteJobResponse> => {
  return fetchWrapRPC<DeleteJobRequest, DeleteJobResponse>(JobService_DeleteJob, {
    basePath: `${mlopsApiUrl}${PATH_PREFIX}`,
  })(request, requestInit);
};

export const listJobs = (
  mlopsApiUrl: string,
  request: ListJobsRequest,
  requestInit?: { signal?: AbortSignal }
): Promise<ListJobsResponse> => {
  return fetchWrapRPC<ListJobsRequest, ListJobsResponse>(JobService_ListJobs, {
    basePath: `${mlopsApiUrl}${PATH_PREFIX}`,
  })(request, requestInit);
};
